<script setup lang="ts">
// Keep the list and URLs in sync with the server-rendered fallback in _signup_static.html.
const logos = [
  {
    src: '/static/images/customers/holiday-check-logo-color.svg',
    width: 288,
    height: 60,
    alt: 'HolidayCheck',
  },
  {
    src: '/static/images/customers/shipsy-logo-color.svg',
    width: 276,
    height: 60,
    alt: 'Shipsy',
  },
  {
    src: '/static/images/customers/stay-22-logo-color.svg',
    width: 197,
    height: 60,
    alt: 'Stay22',
  },
  {
    src: '/static/images/customers/relive-logo-color.svg',
    width: 200,
    height: 60,
    alt: 'Relive',
  },
  {
    src: '/static/images/customers/shadowmap-logo.png',
    width: 1971,
    height: 417,
    alt: 'Shadowmap',
  },
  {
    src: '/static/images/customers/zero-down-logo-color.svg',
    width: 269,
    height: 99,
    alt: 'ZeroDown',
  },
]
</script>

<template>
  <main class="col mt-3">
    <div class="row gx-md-5">
      <router-view />
      <div class="col-md-6 p-3" id="value-add">
        <div class="mb-4">
          <h2>Build for free</h2>
          <p class="lead">
            Get 14 days on Stadia Maps Professional: every API, 200,000 credits,
            no credit card. Privacy-first infrastructure. Your data is yours.
          </p>
        </div>
        <div class="mb-4">
          <h2>You're with friends</h2>
          <p class="lead">
            Used by thousands of developers providing logistics, real estate,
            travel, AI and other solutions. Plus, real human support from the
            team that built it.
          </p>
        </div>
        <div>
          <h2>Trusted by the best</h2>
          <p class="lead">Built by developers, for developers.</p>
          <div id="trust-logos">
            <img
              v-for="logo in logos"
              :key="logo.src"
              :src="logo.src"
              :width="logo.width"
              :height="logo.height"
              :alt="logo.alt"
            />
          </div>
          <p>&hellip;and thousands more.</p>
          <p>
            <a href="https://stadiamaps.com/customer-stories/"
              >See how they use Stadia Maps.</a
            >
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col text-center text-muted mt-3" id="signup-help">
        <p class="mb-1">
          <strong>Questions?</strong> Email us at
          <a href="mailto:support@stadiamaps.com">support@stadiamaps.com</a> or
          check the <a href="https://stadiamaps.com/faqs/">FAQ</a>.
        </p>
        <!-- Plain link on purpose: a soft route swap would bill its layout shift to /signup/'s field CLS. -->
        <p>
          <strong>Already have an account?</strong>{{ ' ' }}
          <a href="/login/">Sign in here</a>.
        </p>
      </div>
    </div>
  </main>
</template>

<style scoped lang="scss"></style>
